<template>
  <a-modal
    title="标签明细"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="onClose"
    :footer="null"
  >
    <a-spin :spinning="loading">
      <lsMetable
        :columns="column"
        :data-list="detailList"
        :scroll="{ y:300 }"
        :IsEdit="false"
        :need-add="false"
        :pagination="false"
      ></lsMetable>
    </a-spin>
    <PickingModal ref="pickingModalRef" />
  </a-modal>
</template>

<script>
import PickingModal from '@/views/mes/workOrderManage/moTickets/components/picking-modal.vue'
import { apiGetReturnLabelDetailList } from '@/api/report/ordinary-report'
export default {
  name: 'LabelDetailModal',
  components: {
    PickingModal
  },
  props: {
    mainBtnLoading: Boolean
  },
  data () {
    return {
      loading: false,
      visible: false,
      type: '', // 弹窗类型
      detailList: [],
      column: [],
      getColumn: [
        { dataIndex: 'itemCode', title: '物料编码', width: 150 },
        { dataIndex: 'label', title: '标签号', width: 150 },
        { dataIndex: 'lotNumber', title: '生产批次号', width: 150 },
        { dataIndex: 'qty', title: '已领数量', width: 150 }
      ],
      returnColumn: [
        { dataIndex: 'itemCode', title: '物料编码', width: 150 },
        { dataIndex: 'label', title: '标签号', width: 150 },
        { dataIndex: 'lotNumber', title: '生产批次号', width: 150 },
        { dataIndex: 'backQty', title: '申请数量', width: 150 },
        { dataIndex: 'backActualQty', title: '接收数量', width: 150 }
      ]
    }
  },
  methods: {
    show (detailId, type) {
      this.column = type === 'get' ? this.getColumn : this.returnColumn;
      this.visible = true;
      this.getDataList(detailId);
    },
    // 获取标签明细
    getDataList(detailId) {
      this.detailList = [];
      this.loading = true;
      apiGetReturnLabelDetailList({ detailId }).then(res => {
        if(res?.code === 200) {
          this.detailList = res?.data || [];
        }else {
          this.$message.error(res?.msg || '获取标签明细失败');
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 关闭模态框
    onClose () {
      this.visible = false;
      this.detailList = [];
    }
  }
}
</script>

<style  scoped lang="less">
</style>
